<template>
    <div v-click-outside="close" class="relative z-50">
        <div @click="toggle" class="cursor-pointer">
            <slot name="trigger"></slot>
        </div>
        <!-- Без анимации (RD-148): opacity-переход отключал размытие стекла до конца анимации,
             меню то появлялось сразу, то «проявлялось». Теперь как остальные меню — сразу. -->
        <div v-if="isOpen" class="toggle-menu absolute z-50 right-0" >
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const isOpen = ref(false);

const toggle = () => {
    isOpen.value = !isOpen.value;
};

// immediately сохранён для совместимости вызова; анимации закрытия больше нет.
const close = (_immediately = false) => {
    isOpen.value = false
};

defineExpose({ close })
</script>

<style scoped>
:global(.slide-fade-enter-active),
:global(.slide-fade-leave-active) {
    transition: max-height 0.5s ease, opacity 0.5s ease;
}

:global(.slide-fade-enter-from),
:global(.slide-fade-leave-to)

/* .slide-fade-leave-active in <2.1.8 */
    {
    max-height: 0;
    opacity: 0;
}

:global(.slide-fade-enter-to),
:global(.slide-fade-leave) {
    max-height: 1000px;
    /* Arbitrary large value for sliding effect */
    opacity: 1;
}

/* Поверхность меню задаёт содержимое слота (единственный consumer — Toolbar, стекло B RD-148):
   без собственного backdrop-filter, чтобы стекло подменю не оказалось вложенным. */
.toggle-menu {
    margin-top: 4px;
}
</style>
